<script setup>
// O ANÚNCIO QUE TROUXE O CLIENTE (clique para o WhatsApp).
//
// 24/09/2026 (WhatsApp oficial): a miniatura que a Meta manda é um endereço do
// Instagram que o navegador não exibe fora do site e que expira em dias — o
// cartão ficava sem imagem e sem o link à vista (Victor: "antes aparecia o link
// do vídeo junto"). Agora: a cópia que o advup guardou (`imagem`, ver
// Advup::Wame::Anuncio) vem primeiro; imagem que não carrega some em vez de
// quebrar; e o link do anúncio aparece escrito.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  referral: { type: Object, required: true },
});

const { t } = useI18n();
const imagemFalhou = ref(false);

const imageUrl = computed(
  () =>
    props.referral.imagem ||
    props.referral.image_url ||
    props.referral.thumbnail_url
);
const headline = computed(() => props.referral.headline);
const body = computed(() => props.referral.body);
const sourceUrl = computed(() => props.referral.source_url);
const video = computed(() => props.referral.media_type === 'video');
</script>

<template>
  <component
    :is="sourceUrl ? 'a' : 'div'"
    :href="sourceUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="flex overflow-hidden rounded-lg bg-n-slate-4 no-underline"
  >
    <span
      v-if="imageUrl && !imagemFalhou"
      class="relative w-16 flex-shrink-0 bg-n-slate-5"
    >
      <img
        :src="imageUrl"
        class="absolute inset-0 size-full object-cover"
        alt=""
        @error="imagemFalhou = true"
      />
      <span
        v-if="video"
        class="absolute inset-0 grid place-items-center text-white"
        aria-hidden="true"
      >
        <i class="i-ph-play-circle-fill size-6 drop-shadow" />
      </span>
    </span>
    <div class="flex flex-col gap-1 px-3 py-2 min-w-0">
      <p
        v-if="headline"
        class="mb-0 text-sm font-semibold text-n-slate-12 line-clamp-2"
      >
        {{ headline }}
      </p>
      <p v-if="body" class="mb-0 text-xs text-n-slate-11 line-clamp-3">
        {{ body }}
      </p>
      <span
        v-if="sourceUrl"
        class="inline-flex items-center gap-1 text-xs font-medium text-n-blue-11"
      >
        <i
          :class="video ? 'i-ph-play-fill' : 'i-ph-megaphone-simple-fill'"
          class="size-3"
          aria-hidden="true"
        />
        {{ t('CONVERSATION.ANUNCIO.VER') }}
        <i class="i-ph-arrow-square-out size-3" aria-hidden="true" />
      </span>
    </div>
  </component>
</template>
